var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('ul',{staticClass:"operate-list"},[_c('li',{on:{"click":_vm.gotoRecordList}},[_vm._v("打卡记录")]),_vm._v("    |     "),_c('li',{on:{"click":_vm.gotoHelp}},[_vm._v("打卡说明")])])])}
var staticRenderFns = []

export { render, staticRenderFns }